const getVisiblePages = (currentPage, totalPages) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = [1, 2];
  if (currentPage > 4) pages.push("start-ellipsis");

  for (let page = currentPage - 1; page <= currentPage + 1; page += 1) {
    if (page > 2 && page < totalPages - 1) pages.push(page);
  }

  if (currentPage < totalPages - 3) pages.push("end-ellipsis");
  pages.push(totalPages - 1, totalPages);
  return [...new Set(pages)];
};

const Pagination = ({
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  disabled = false,
  className = "",
}) => {
  const safeTotalPages = Math.max(Number(totalPages) || 1, 1);
  const safeCurrentPage = Math.min(
    Math.max(Number(currentPage) || 1, 1),
    safeTotalPages,
  );

  if (safeTotalPages <= 1) return null;

  const changePage = (page) => {
    if (
      disabled ||
      page === safeCurrentPage ||
      page < 1 ||
      page > safeTotalPages
    ) {
      return;
    }
    onPageChange?.(page);
  };

  return (
    <nav
      className={`flex items-center gap-2 ${className}`}
      aria-label="Phân trang"
    >
      <button
        type="button"
        onClick={() => changePage(safeCurrentPage - 1)}
        disabled={disabled || safeCurrentPage === 1}
        className="rounded p-1 hover:bg-gray-200 disabled:opacity-50"
        aria-label="Trang trước"
      >
        <img src="/icons/left-arrow-black.svg" alt="" />
      </button>

      {getVisiblePages(safeCurrentPage, safeTotalPages).map((page) =>
        typeof page === "string" ? (
          <span key={page} aria-hidden="true">
            ...
          </span>
        ) : (
          <button
            type="button"
            key={page}
            onClick={() => changePage(page)}
            disabled={disabled}
            className={`rounded px-3 py-1 ${
              page === safeCurrentPage
                ? "border border-blue-500 text-blue-500"
                : "hover:bg-blue-200"
            } disabled:cursor-wait disabled:opacity-70`}
            aria-current={page === safeCurrentPage ? "page" : undefined}
          >
            {page}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => changePage(safeCurrentPage + 1)}
        disabled={disabled || safeCurrentPage === safeTotalPages}
        className="rounded p-1 hover:bg-gray-200 disabled:opacity-50"
        aria-label="Trang sau"
      >
        <img src="/icons/right-arrow-black.svg" alt="" />
      </button>
    </nav>
  );
};

export default Pagination;
